import { render, staticRenderFns } from "./BannersManager.vue?vue&type=template&id=4c70feb0&"
import script from "./BannersManager.vue?vue&type=script&lang=js&"
export * from "./BannersManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports